import CarTagIcon from 'components/icons/CarTagIcon';
import DashboardIcon from 'components/icons/DashboardIcon';
import InstantMixIcon from 'components/icons/InstantMixIcon';
import EditRoadIcon from 'components/icons/EditRoadIcon';
import ManajemenContentIcon from 'components/icons/ManajemenContentIcon';
import PersonRaisedHandIcon from 'components/icons/PersonRaisedHandIcon';
import CarRentalIcon from 'components/icons/CarRentalIcon';
import FindInPageIcon from 'components/icons/FindInPageIcon';
import DataTableIcon from 'components/icons/DataTableIcon';
import InventoryIcon from 'components/icons/InventoryIcon';
import TabProfileIcon from 'components/icons/TabProfileIcon';
import DiversityIcon from 'components/icons/DiversityIcon';

/**
 * NOTE:
 * - subMenu yang butuh dynamic data (Inventory/productTypes)
 *   HARUS diinjeksi di SideNavBar, bukan di sini
 */
export const menuConfig = [
  {
    name: 'Dashboard',
    link: '/dashboard',
    icon: DashboardIcon,
  },
  {
    name: 'Penerimaan Unit',
    link: '/acceptance',
    icon: CarTagIcon,
    subMenu: [
      { name: 'Penerimaan Web', link: '/web' },
      { name: 'Penerimaan Partner', link: '/partner' },
    ],
  },
  {
    name: 'Pengiriman Unit',
    link: '/mobilization',
    icon: EditRoadIcon,
  },
  {
    name: 'Review Dokumen',
    link: '/review-document',
    icon: FindInPageIcon,
  },
  {
    name: 'Inventory',
    link: '/inventory',
    icon: InventoryIcon,
    // subMenu dinamis → di SideNavBar
  },
  {
    name: 'Lelang',
    link: '/auction',
    icon: PersonRaisedHandIcon,
    subMenu: [
      { name: 'List Lelang', link: '/list' },
      { name: 'Biaya Admin', link: '/admin-fee' },
    ],
  },
  {
    name: 'Transaksi',
    link: '/transaction',
    icon: PersonRaisedHandIcon,
  },
  {
    name: 'Laporan',
    link: '/statement',
    icon: TabProfileIcon,
    subMenu: [
      { name: 'Laporan Lelang', link: '/auction' },
      { name: 'Laporan MOU', link: '/mou' },
      { name: 'Laporan Pembayaran Seller', link: '/seller-payment' },
    ],
  },
  {
    name: 'Rilis Kendaraan',
    link: '/vehicle-release',
    icon: CarRentalIcon,
  },
  {
    name: 'Pelanggan',
    link: '/customer',
    icon: DiversityIcon,
    subMenu: [
      { name: 'Basic', link: '/basic' },
      { name: 'Premium', link: '/premium' },
      { name: 'Biaya Seller', link: '/auction-fee' },
      { name: 'Request Refund', link: '/request-refund' },
      { name: 'Virtual Account', link: '/virtual-account' },
      // { name: 'List Seller', link: '/list-seller' },
    ],
  },
  {
    name: 'Manajemen Konten',
    link: '/content',
    icon: ManajemenContentIcon,
    subMenu: [
      { name: 'Banner', link: '/banner' },
      { name: 'Blog', link: '/blog' },
      { name: 'Tentang Kami', link: '/about' },
      { name: 'FAQ', link: '/faq' },
      { name: 'Prosedur', link: '/procedure' },
    ],
  },
  {
    name: 'Master Data',
    link: '/master',
    icon: DataTableIcon,
    subMenu: [
      {
        name: 'Produk',
        link: '/product',
        childs: [
          { name: 'Tipe Produk', link: '/type' },
          { name: 'Segmen', link: '/segmen' },
          { name: 'Tag', link: '/tag' },
        ],
      },
      {
        name: 'Inspeksi',
        link: '/inspection',
        childs: [
          { name: 'Bagian Inspeksi', link: '/part' },
          { name: 'Kategori Inspeksi', link: '/category' },
          { name: 'Penilaian Inspeksi', link: '/assessment' },
        ],
      },
    ],
  },
  {
    name: 'Pengaturan',
    link: '/settings',
    icon: InstantMixIcon,
  },
];
